export default "__VITE_ASSET__BQmWH$Hh__"